var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-tab-item", {
    attrs: { value: _vm.tabCode, transition: false },
    scopedSlots: _vm._u(
      [
        {
          key: "default",
          fn: function () {
            return [
              _c(
                "v-card",
                { attrs: { flat: "" } },
                [
                  _c(
                    "v-card-text",
                    {
                      staticClass: "step-container",
                      class: "step-container__" + _vm.tabCode,
                    },
                    [
                      _vm._t("default", function () {
                        return [
                          _c("h2", {
                            staticClass: "page-title page-title__primary",
                            domProps: { innerHTML: _vm._s(_vm.title) },
                          }),
                          _vm._t("description", function () {
                            return [
                              _vm.description
                                ? _c("p", {
                                    domProps: {
                                      innerHTML: _vm._s(_vm.description),
                                    },
                                  })
                                : _vm._e(),
                            ]
                          }),
                          _vm._t("content", null, { data: _vm.value }),
                          _vm._t("error", function () {
                            return [
                              _vm.error
                                ? _c("v-alert", {
                                    staticClass: "mt-4",
                                    attrs: { type: "error", color: "red" },
                                    domProps: { innerHTML: _vm._s(_vm.error) },
                                  })
                                : _vm._e(),
                            ]
                          }),
                          _vm.showFiles
                            ? _vm._t("files", function () {
                                return [
                                  _c(
                                    "div",
                                    { staticClass: "mb-8 mt-4" },
                                    _vm._l(_vm.files, function (file) {
                                      return _c(
                                        "v-chip",
                                        {
                                          key: file.name,
                                          staticClass: "mr-2",
                                          attrs: {
                                            color: "primary",
                                            outlined: "",
                                            small: "",
                                            close: "",
                                          },
                                          on: {
                                            "click:close": function ($event) {
                                              return _vm.removeFile(file)
                                            },
                                          },
                                        },
                                        [_vm._v(_vm._s(file.name))]
                                      )
                                    }),
                                    1
                                  ),
                                ]
                              })
                            : _vm._e(),
                          _vm.enableUpload
                            ? _vm._t(
                                "upload",
                                function () {
                                  return [
                                    _c(
                                      "v-btn",
                                      {
                                        staticClass: "mr-4",
                                        attrs: {
                                          color: "primary",
                                          elevation: "0",
                                          loading: _vm.isUploading,
                                        },
                                        on: { click: _vm.showSelectFileDialog },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.hasData
                                              ? _vm.showFiles
                                                ? "Добавить данные"
                                                : "Заменить данные"
                                              : "Загрузить данные"
                                          )
                                        ),
                                      ]
                                    ),
                                    _vm.hasData && _vm.showFiles
                                      ? _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              color: "primary",
                                              elevation: "0",
                                            },
                                            on: { click: _vm.approve },
                                          },
                                          [_vm._v(" Подтвердить ")]
                                        )
                                      : _vm._e(),
                                    _vm.single
                                      ? _c("input", {
                                          ref: "uploader",
                                          staticClass: "d-none",
                                          attrs: { type: "file" },
                                          on: { change: _vm.onFileChanged },
                                        })
                                      : _c("input", {
                                          ref: "uploader",
                                          staticClass: "d-none",
                                          attrs: {
                                            type: "file",
                                            multiple: "multiple",
                                          },
                                          on: { change: _vm.onFileChanged },
                                        }),
                                  ]
                                },
                                { data: _vm.value }
                              )
                            : _vm._e(),
                          _vm._t("extra", null, { data: _vm.value }),
                        ]
                      }),
                    ],
                    2
                  ),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }